// src/helpers/ui-state.js

import React from 'react'
import each from 'lodash/each'
import shallowEqual from './shallow-equal'

function getState(state, props) {
  let _state = {}
  each(state, (value, key)=> {
    _state[key] = typeof value == 'function' ? value(props) : value
  })
  return _state
}

/*
  ui(opts)(Component)とすることで、Componentコンポーネントの props に updateUI メソッド, ui オブジェクトが埋め込まれる。
  コンポーネント内からは、
    - this.props.ui で ui を参照することができる
    - this.props.updateUI で ui を書き換えることができる
    - this.props.resetUI で ui を初期値に戻すことができる
  optsには以下の内容を指定する:
    - state: uiの初期状態
  redux-uiの簡易的な置き換えが可能、かつこの実装の方がおそらく高速に動作する
*/
export default function ui(opts = { inherit: true }) {
  return (Component)=> {
    class UIComponent extends React.Component {
      constructor(props, context) {
        super(props, context)
        this.state = { ui: getState(opts.state, props) }
      }

      shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState)
      }

      _resetState = ()=> this.setState({ ui: getState(opts.state, this.props) })
      _setState = (state)=> this.setState((_state)=> ({ ui: Object.assign({}, _state.ui, state) }))

      render() {
        return <Component {...this.props} ui={this.state.ui} updateUI={this._setState} resetUI={this._resetState} />
      }
    }

    UIComponent.displayName = `ui(${Component.displayName})`
    return UIComponent
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ui-state.js